import React, { useEffect, useRef, useState } from 'react';
import StarRating from '../../components/rating';
import ReviewCard from '../../components/ReviewCard';
import CustomCarousel from '../../components/carousel';
import business from '../../images/business.svg'
import line from '../../images/icons/line.svg'
import mark from '../../images/icons/mark.svg'
import envelope from '../../images/icons/envolope.svg'
import call from '../../images/icons/call.svg';
import web from '../../images/icons/web.svg'
import emailConfirm from '../../images/emailConfirm.svg'
import Card from '../../components/Card';
import camera from '../../images/icons/camera.svg'
import closeimage from '../../images/icons/closeimage.svg'
import { ColorRing } from 'react-loader-spinner';
import axios from 'axios';


function BusinessDetailsBody() {
    const [reviews, setReviews] = useState([
    ])

    const [openingHours, setOpeningHours] = useState([
        {day:'Monday',opening:'08:00',closing:'16:00'},
        {day:'Tuesday',opening:'08:00',closing:'16:00'},
        {day:'Wednesday',opening:'08:00',closing:'16:00'}
    ])

        const [cards, setCards] = useState([
        ])

    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);
    const [userRating, setUserRating] = useState(0); 
    const handleRatingChange = (newRating) => {
        setUserRating(newRating);
        InputReviewData(newRating,'feedbackRating')
      };
    
    const [startRecommendation, setStartRecommendation] = useState(0)
    const [emailSent, setEmailSent] = useState(0)
    const [email, setEmail] = useState(0)
    const [recData,setRecData] = useState({businessProfileId:sessionStorage.getItem('businessId')})
    const sendEmail = (e) => {
        setProcessing(1)
        e.preventDefault()
        recData.email = email
        axios.post(process.env.REACT_APP_BASE_URL+'/Business/RegisterRecommendation/',recData,{})
        .then((res) => {
            if(res.data.data.isSuccess){
                setStartRecommendation(0)
                setProcessing(0)
                setEmailSent(1)
            }else{
                setProcessing(0)
                alert(res.data.data.messsage)
            }
        }
        )
        .catch((e) => {
            console.log(e)
        })
    }

    const [image, setImage] = useState(null);
    const fileInputRef = useRef(null);
  
    const handleFileChange = (event) => {
      const file = event.target.files[0];
      alert(file)
    //   return
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setImage(reader.result);
        };
        reader.readAsDataURL(file);
      }
    };
  
    const triggerFileSelect = () => {
      fileInputRef.current.click();
    };
    let [fetched, setFetched] = useState()
    const [busDetails, setBusDetails] = useState({})
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    useEffect(() => {
        axios.get(process.env.REACT_APP_BASE_URL+'/Business/Details/'+sessionStorage.getItem('businessId'),{})
        .then((res) => {
            if(res.status == 200){
                setBusDetails(res.data.data.profile)
            }}
        )
        .then(() => {
            axios.get(process.env.REACT_APP_BASE_URL+'/Feedback/Feedback/'+sessionStorage.getItem('businessId'),{})
            .then((res) => {
                if(res.status == 200){
                    setReviews(res.data.data)
                }
                })
        })
        .then(() => {
            axios.get(process.env.REACT_APP_BASE_URL+'/Business/List/'+sessionStorage.getItem('categoryId'),{})
            .then((res) => {
                if(res.status == 200){
                    setCards(res.data.data)
                }
                })
        })
        .then(() => {
            axios.get(process.env.REACT_APP_BASE_URL+'/BusinessHour/'+sessionStorage.getItem('businessId'),{})
            .then((res) => {
                if(res.status == 200){
                    
                    const updatedData = res.data.data.map(entry => ({
                        ...entry,
                        dayOfWeek: days[entry.dayOfWeek]
                      }));
                    console.log(updatedData)
                    setOpeningHours(updatedData)
                    setFetched(1)
                }
                })
        })
        .catch((e) => {
            console.log(e)
        })
    }, [])

    const [newReviewData, setNewReviewData] = useState({businessProfileId:sessionStorage.getItem('businessId')})

    const InputReviewData = (value,field) => {
        setNewReviewData({...newReviewData,[field] : value})
    }
    
    const [processing, setProcessing] = useState(0)
    const SubmitReview = (e) => {
        setProcessing(1)
        e.preventDefault()
        axios.post(process.env.REACT_APP_BASE_URL+'/Feedback/Feedback/Create',newReviewData,{})
        .then((res) => {
            if(res.status == 200){
                alert('Review completed successfully')
                setProcessing(0)
                setIsOpen(0)
                window.location.href=''
            }}
        )
        .catch((e) => {
            console.log(e)
        })
    }

    return (
        <>
        { startRecommendation ? (
            <>
            <div>
            <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-40" onClick={closeModal}></div>
                <div className="fixed inset-0 z-50 flex items-center justify-center text-start">
                    <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl font-semibold">Provide Recommendation</h2>
                        <button
                        onClick={() => setStartRecommendation(0)}
                        className="text-gray-400 hover:text-gray-600"
                        >
                        &times;
                        </button>
                    </div>
                    <form className="mt-4" onSubmit={sendEmail}>
                        <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">
                            Email
                        </label>
                        <input
                            type="email"
                            placeholder="Email"
                            required
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                        />
                        </div>
                        <button
                        type="submit"
                        disabled = {processing ? true : false}
                        className="w-full bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600"
                        >
                        Begin Recommendation
                        </button>
                    </form>
                    </div>
                </div>
                </div>
            </>
        ) : ''
        }

{ emailSent ? (
            <>
            <div>
                <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-40" onClick={closeModal}></div>
                <div className="fixed inset-0 z-50 flex items-center justify-center text-start">
                    <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl font-semibold"></h2>
                        <button
                        onClick={() => setEmailSent(0)}
                        className="text-gray-400 hover:text-gray-600"
                        >
                        &times;
                        </button>
                    </div>
                    <form className="mt-4">
                        <div className="mb-3 flex flex-col items-center">
                            <span><img src={emailConfirm} /></span>
                            <span className='text-[#667085]'>We have sent a link to <span className='text-[#008B39]'>{email}</span> for you to continue your recommendation. After receiving the email follow the link provided to recommend a business successfully. </span>
                        </div>
                        <button
                        type="button" onClick={() => setEmailSent(0)}
                        className="w-full bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600"
                        >
                        Cancel
                        </button>
                    </form>
                    </div>
                </div>
                </div>
            </>
        ) : ''
        }
        {isOpen && (
        <div>
          <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-40" onClick={closeModal}></div>
          <div className="fixed inset-0 z-50 flex items-center justify-center text-start">
            <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6">
              <div className="flex justify-between items-center">
                <h2 className="text-xl font-semibold">Write a review</h2>
                <button
                  onClick={closeModal}
                  className="text-gray-400 hover:text-gray-600"
                >
                  &times;
                </button>
              </div>
              <form className="mt-4" onSubmit={(e) =>SubmitReview(e)}>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Name
                  </label>
                  <input
                    type="text"
                    required
                    onChange={(e) => InputReviewData(e.target.value,'feedbackWriter')}
                    placeholder="First name"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Rating
                  </label>
                  <div className="">
                    <StarRating 
                        rating={userRating} 
                        maxRating={5} 
                        onRatingChange={handleRatingChange} 
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Review
                  </label>
                  <input
                    onChange={(e) => InputReviewData(e.target.value,'feedbackTitle')}
                    type="text"
                    placeholder="Header"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
                <div className="mb-4">
                  <textarea
                    onChange={(e) => InputReviewData(e.target.value,'feedbackValue')}
                    placeholder="Type review details here"
                    className="w-full h-32 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Add photo (Optional)
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                />
                {image ? 
                <div className='relative w-48 h-48'>
                    <span onClick={() => setImage(null)} className='absolute cursor-pointer bg-white w-5 h-5 rounded-full grid top-2 right-2 z-50 flex items-center justify-center'>
                        <img src={closeimage} />
                    </span>
                    <div className='relative'>
                        <img
                            src={image}
                            alt="Selected Preview"
                            className="mt-4 w-48 h-48 object-cover rounded-lg shadow-lg"
                        />
                    </div>
                </div>
                     : 
                <div onClick={triggerFileSelect} className="mt-3 w-[82px] hover:bg-gray-300 h-[82px] bg-[#EFEFEF] rounded-[4px] p-4 flex justify-center items-center cursor-pointer">
                <div><img src={camera} /></div>
                </div>
                }
                </div>
                <button
                  type="submit"
                  disabled={processing ? true : false}
                  className="w-full bg-[#008B39] text-white py-2 px-4 rounded-[32px] hover:bg-green-600"
                >
                  Submit review
                </button>
              </form>
            </div>
          </div>
        </div>
        )}
        {!fetched ? 
        <div className='items-center grid mx-auto w-[80px] h-[80px] text-center py-20 mb-10'>
        <ColorRing
            visible={true}
            height="80"
            width="80"
            ariaLabel="color-ring-loading"
            wrapperStyle={{}}
            wrapperClass="color-ring-wrapper"
            colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
            className="mx-auto"
            />
            </div>
             : 
        <div className='flex flex-col p-5 lg:p-20'>
            <div className='rounded-[8px] border-[1px] px-5 pb-8 lg:p-10 flex flex-col lg:flex-row lg:space-x-5 items-center'>
                <div><img className='w-[388px] h-[330.29px] rounded-[8px]' src={busDetails.profileImage ? busDetails.profileImage.originalUrl : business} /></div>
                <div className='flex flex-col text-start space-y-8'>
                    <div className='flex flex-col'>
                        <span className='text-[24px] lg:text-[44px] font-[500]'>{busDetails.name}</span>
                        <div className='flex flex-row space-x-1 lg:space-x-3 items-center'>
                            <div>
                                <StarRating 
                                    rating={busDetails.rating} 
                                    maxRating={5} 
                                    readOnly 
                                />
                            </div>
                            <div><img src={line} /></div>
                            <div>{busDetails.recommendationCount} Recommendation(s)</div>
                        </div>
                    </div>
                    <div className='flex flex-col lg:flex-row space-y-3 lg:space-y-0 lg:space-x-5'>
                        <span onClick={openModal} className='cursor-pointer rounded-[32px] bg-white border-[1px] border-[#008B39] text-[#008B39] px-4 py-3 text-center'>Write Review</span>
                        <span onClick={() => setStartRecommendation(1)} className='cursor-pointer rounded-[32px] bg-[#008B39] text-white px-4 py-3 text-center'>Provide Recommendation</span>
                    </div>
                </div>
            </div>
            <div className='grid grid-cols-8 mt-10 space-x-8'>
                <div className='col-span-8 lg:col-span-6'>
                    <CustomCarousel
                        defaultItemsPerSlide={1}
                        defaultRows={5}
                        responsive={[
                            { breakpoint: 1024, itemsPerSlide: 1, rows: 2 },
                            { breakpoint: 768, itemsPerSlide: 2, rows: 2 },
                            { breakpoint: 480, itemsPerSlide: 2, rows: 3 },
                        ]}
                    >
                        {reviews.map((item, index) => (
                            <ReviewCard key={index} className="" {...item}></ReviewCard>
                        ))}
                    </CustomCarousel>
                </div>
                <div className='col-span-8 lg:col-span-2 rounded-[8px] border-[1px] p-2 flex flex-col space-y-3 text-start'>
                    <div className='flex flex-col'>
                        <span className='text-[#141414] text-[18px]'>About {busDetails.name}</span>
                        <span className='text-[#737373]' dangerouslySetInnerHTML={{ __html: busDetails ? busDetails.description :'' }}>
                        </span>
                        <hr className='mt-3'></hr>
                    </div>
                    <div className='flex flex-col '>
                        <span className='text-[#141414] text-[18px] mb-2'>Contact</span>
                        <div className='text-[#737373] flex flex-col space-y-2'>
                            {busDetails.physicalAddress ?
                            <div className='flex flex-row space-x-2'>
                                <div><img src={mark} /></div>
                                <div>{busDetails.physicalAddress}</div>
                            </div>
                            : '' }
                            {busDetails.emailAddress ?
                            <div className='flex flex-row space-x-2'>
                                <div><img src={envelope} /></div>
                                <div>{busDetails.emailAddress}</div>
                            </div>
                            : '' }
                            {busDetails.phoneNumber ?
                            <div className='flex flex-row space-x-2'>
                                <div><img src={call} /></div>
                                <div>{busDetails.phoneNumber}</div>
                            </div>
                            : '' }
                            {busDetails.website ?
                            <div className='flex flex-row space-x-2'>
                                <div><img src={web} /></div>
                                <div>{busDetails.website}</div>
                            </div>
                            : '' }
                        </div>
                        <hr className='mt-3'></hr>
                    </div>
                    {openingHours.length > 0 ? 
                        <div className='flex flex-col '>
                        <span className='text-[#141414] text-[18px] mb-2'>Opening Hours</span>
                        <div className='text-[#737373] flex flex-col space-y-2'>
                            {openingHours.map(({dayOfWeek,openingTime,closingTime}) => {
                                return ( 
                                    <div className='flex flex-row space-x-2'>
                                        <div>{dayOfWeek}</div>
                                        <div>{openingTime}</div>
                                        <div>-</div>
                                        <div>{closingTime}</div>
                                    </div>
                                )
                            })}
                        </div>
                        <hr className='mt-3'></hr>
                    </div>  : ''
                }
                </div>  
            </div>
            <div className='flex flex-col space-y-3'>
                <span className='text-start font-[500] text-[20px] lg:text-[36px]'>Similar Businesses</span>
                <div>
                    <CustomCarousel
                        defaultItemsPerSlide={3}
                        defaultRows={3}
                        responsive={[
                            { breakpoint: 1024, itemsPerSlide: 1, rows: 2 },
                            { breakpoint: 768, itemsPerSlide: 2, rows: 2 },
                            { breakpoint: 480, itemsPerSlide: 2, rows: 3 },
                        ]}
                    >
                        {cards.filter(item => item.id !== sessionStorage.getItem('businessId')).slice(0,6).map((item, index) => (
                            <Card key={index} className="" {...item}></Card>
                        ))}
                    </CustomCarousel>
                </div>
            </div>
        </div>
            }
        </>
    );
}

export default BusinessDetailsBody;